// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3E%3Cpath stroke=%27%236B7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.4 | MIT License | https://tailwindcss.com */
@layer properties;
.select-floating-wrapper .select-floating {
  position: relative;
  select {
    display: block;
    height: calc(var(--spacing, 0.25rem) * 9);
    width: 100%;
    appearance: none;
    border-radius: 0.25rem;
    --tw-border-style: none;
    border-style: none;
    background-color: var(--color-white, #fff);
    padding-inline: calc(var(--spacing, 0.25rem) * 2);
    color: var(--color-gray-900, oklch(21% 0.034 264.665));
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
    outline-color: var(--color-gray-300, oklch(87.2% 0.01 258.338));
    &:hover {
      @media (hover: hover) {
        outline-color: var(--color-gray-500, oklch(55.1% 0.027 264.364));
      }
    }
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      outline-color: var(--color-gray-500, oklch(55.1% 0.027 264.364));
    }
    &:disabled {
      cursor: not-allowed;
    }
    &:disabled {
      background-color: var(--color-gray-100, oklch(96.7% 0.003 264.542));
    }
    &:disabled {
      color: var(--color-gray-400, oklch(70.7% 0.022 261.325));
    }
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: right 0.5rem center;
    background-repeat: no-repeat;
    background-size: 1.5em 1.5em;
    padding-right: 2.5rem;
  }
  label {
    pointer-events: none;
    position: absolute;
    top: calc(var(--spacing, 0.25rem) * 1.5);
    left: calc(var(--spacing, 0.25rem) * 1);
    z-index: 10;
    transform-origin: 0;
    --tw-translate-y: calc(var(--spacing, 0.25rem) * -4);
    translate: var(--tw-translate-x) var(--tw-translate-y);
    --tw-scale-x: 75%;
    --tw-scale-y: 75%;
    --tw-scale-z: 75%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    background-color: var(--color-white, #fff);
    padding-inline: calc(var(--spacing, 0.25rem) * 2);
    color: var(--color-gray-400, oklch(70.7% 0.022 261.325));
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  &:not(.has-value) {
    select:not(:focus) + label {
      top: calc(1 / 2 * 100%);
      --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
      --tw-scale-x: 90%;
      --tw-scale-y: 90%;
      --tw-scale-z: 90%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
  select:focus + label {
    top: calc(var(--spacing, 0.25rem) * 1.5);
    --tw-translate-y: calc(var(--spacing, 0.25rem) * -4);
    translate: var(--tw-translate-x) var(--tw-translate-y);
    --tw-scale-x: 75%;
    --tw-scale-y: 75%;
    --tw-scale-z: 75%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
    padding-inline: calc(var(--spacing, 0.25rem) * 2);
    color: var(--color-gray-600, oklch(44.6% 0.03 256.802));
  }
  &.has-icon {
    select {
      padding-left: calc(var(--spacing, 0.25rem) * 8);
    }
    label {
      left: calc(var(--spacing, 0.25rem) * 2.5);
    }
    &:not(.has-value) select:not(:focus) + label {
      left: calc(var(--spacing, 0.25rem) * 5);
    }
    select:focus + label {
      left: calc(var(--spacing, 0.25rem) * 2.5);
    }
    .input-icon {
      position: absolute;
      top: calc(1 / 2 * 100%);
      left: calc(var(--spacing, 0.25rem) * 2);
      --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
      color: var(--color-gray-400, oklch(70.7% 0.022 261.325));
    }
  }
  &.has-error {
    select {
      border-color: var(--color-red-500, oklch(63.7% 0.237 25.331));
      &:focus {
        border-color: var(--color-red-600, oklch(57.7% 0.245 27.325));
      }
    }
    label {
      color: var(--color-red-500, oklch(63.7% 0.237 25.331));
      &:is(:where(.peer):focus ~ *) {
        color: var(--color-red-600, oklch(57.7% 0.245 27.325));
      }
    }
  }
}
.select-floating-wrapper .input-error-message {
  margin-top: calc(var(--spacing, 0.25rem) * 1);
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  color: var(--color-red-500, oklch(63.7% 0.237 25.331));
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-outline-style: solid;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-duration: initial;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./app/Components/Forms/select-floating/select-floating.component.css"],"names":[],"mappings":"AAAA,iEAAA;ACWsD,iBAAO;AAL7D;EACW,kBAAQ;EAEf;IACoB,cAAK;IAAgC,yCAAG;IAAlC,WAAM;IAAC,gBAAe;IAAC,sBAAO;IACmB,uBAAW;IAAX,kBAAW;IAD3E,0CAAQ;IAA0C,iDAAI;IAAC,sDAAa;IAC7B,sCAAO;IAAP,kBAAO;IAAC,+DAAgB;IAAtE;MAAA;QAAA,gEAAsB;MAAA;IAAA;IAA6D;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAxE;MAAA,gEAAsB;IAAA;IACtC;MAAA,mBAA2B;IAAA;IAAC;MAAA,mEAAoB;IAAA;IAAC;MAAA,wDAAsB;IAAA;IAG9E,yDAAkQ;IAClQ,wCAAyC;IACzC,4BAA6B;IAC7B,4BAA6B;IAC7B,qBAAsB;EACzB;EAED;IACwI,oBAAmB;IAAhJ,kBAAQ;IAAQ,wCAAO;IAAd,uCAAM;IAAS,WAAI;IAAC,mBAAU;IAAC,oDAAc;IAAd,sDAAc;IAAC,iBAAQ;IAAR,iBAAQ;IAAR,iBAAQ;IAAR,0CAAQ;IAAC,0GAAS;IAAU,+BAAS;IAAT,gCAAS;IAAlB,0CAAQ;IAAW,iDAAI;IAAC,wDAAa;IAAC,oBAAY;IAAZ,0BAAY;EACtI;EAUD;IACI;MACW,uBAAO;MAAC,+CAAgB;MAAhB,sDAAgB;MAAC,iBAAQ;MAAR,iBAAQ;MAAR,iBAAQ;MAAR,0CAAQ;IAC3C;EACJ;EAED;IACW,wCAAO;IAAC,oDAAc;IAAd,sDAAc;IAAC,iBAAQ;IAAR,iBAAQ;IAAR,iBAAQ;IAAR,0CAAQ;IAAC,iDAAI;IAAC,uDAAa;EAC5D;EAED;IACI;MACW,+CAAI;IACd;IAED;MACW,yCAAQ;IAClB;IAED;MACW,uCAAM;IAChB;IAED;MACW,yCAAQ;IAClB;IAED;MACW,kBAAQ;MAAQ,uBAAO;MAAd,uCAAM;MAAS,+CAAgB;MAAhB,sDAAgB;MAAC,wDAAa;IAChE;EACJ;EAED;IACI;MACW,6DAAc;MAAC;QAAA,6DAAoB;MAAA;IAC7C;IAED;MACW,sDAAY;MAAC;QAAA,sDAAuB;MAAA;IAC9C;EACJ;AACJ;AAED;EACW,6CAAI;EAAC,kCAAO;EAAP,2EAAO;EAAC,sDAAY;AACnC;AApEqD;EAAA,WAAO;EAAP,eAAO;EAAP,oBAAO;AAAA;AAA8B;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,sBAAY;EAAZ,eAAY;EAAZ,mBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,sBAAY;EAAZ,eAAY;EAAZ,mBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,kBAAY;EAAZ,eAAY;EAAZ,kBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,mBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAYhD;EAAA,WAAc;EAAd,eAAc;EAAd,gBAAc;AAAA;AAAd;EAAA,WAAc;EAAd,eAAc;EAAd,gBAAc;AAAA;AAAd;EAAA,WAAc;EAAd,eAAc;EAAd,gBAAc;AAAA;AAAC;EAAA,WAAQ;EAAR,eAAQ;EAAR,gBAAQ;AAAA;AAAR;EAAA,WAAQ;EAAR,eAAQ;EAAR,gBAAQ;AAAA;AAAR;EAAA,WAAQ;EAAR,eAAQ;EAAR,gBAAQ;AAAA;AAAC;EAAA,WAAS;EAAT,eAAS;AAAA;AAAT;EAAA,WAAS;EAAT,eAAS;AAAA;AAAT;EAAA,WAAS;EAAT,eAAS;AAAA;AAAT;EAAA,WAAS;EAAT,eAAS;AAAA;AAAT;EAAA,WAAS;EAAT,eAAS;AAAA;AAAuC;EAAA,WAAY;EAAZ,eAAY;AAAA;AAZrF;EAAA;IAAA;MAAA,yBAAO;MAA8B,sBAAY;MAAZ,0BAAY;MAAZ,uBAAY;MAAZ,4BAAY;MAAZ,gCAAY;MAAZ,6BAAY;MAAZ,wBAAY;MAAZ,2BAAY;MAAZ,8BAAY;MAAZ,iCAAY;MAAZ,wBAAY;MAAZ,2BAAY;MAAZ,4BAAY;MAAZ,kCAAY;MAYhD,mBAAc;MAAd,mBAAc;MAAd,mBAAc;MAAC,eAAQ;MAAR,eAAQ;MAAR,eAAQ;MAAC,sBAAS;MAAT,sBAAS;MAAT,sBAAS;MAAT,oBAAS;MAAT,oBAAS;MAAuC,sBAAY;IAZ9E;EAAA;AAAA","sourcesContent":[null,"@reference '../../../assets/css/main.css'\r\n\r\n.select-floating-wrapper {\r\n    @apply w-full;\r\n}\r\n\r\n.select-floating-wrapper .select-floating {\r\n    @apply relative;\r\n\r\n    select {\r\n        @apply bg-white block w-full appearance-none rounded h-9 px-2 text-gray-900\r\n        hover:outline-gray-500 focus:outline-gray-500 outline outline-gray-300 border-none focus:ring-0;\r\n        @apply disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400;\r\n\r\n        /* Custom arrow for select */\r\n        background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236B7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3E%3C/svg%3E\");\r\n        background-position: right 0.5rem center;\r\n        background-repeat: no-repeat;\r\n        background-size: 1.5em 1.5em;\r\n        padding-right: 2.5rem;\r\n    }\r\n\r\n    label {\r\n        @apply absolute left-1 top-1.5 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white rounded-t px-2 text-gray-400 duration-300 pointer-events-none;\r\n    }\r\n\r\n    /* When select has no value and is not focused */\r\n\r\n    select:not(:focus):not(.has-value) + label {\r\n        /* This is tricky for select because they often have a default empty value */\r\n    }\r\n\r\n    /* We use the has-value class from controller to handle the floating state */\r\n\r\n    &:not(.has-value) {\r\n        select:not(:focus) + label {\r\n            @apply top-1/2 -translate-y-1/2 scale-90;\r\n        }\r\n    }\r\n\r\n    select:focus + label {\r\n        @apply top-1.5 -translate-y-4 scale-75 px-2 text-gray-600;\r\n    }\r\n\r\n    &.has-icon {\r\n        select {\r\n            @apply pl-8;\r\n        }\r\n\r\n        label {\r\n            @apply left-2.5;\r\n        }\r\n\r\n        &:not(.has-value) select:not(:focus) + label {\r\n            @apply left-5;\r\n        }\r\n\r\n        select:focus + label {\r\n            @apply left-2.5;\r\n        }\r\n\r\n        .input-icon {\r\n            @apply absolute left-2 top-1/2 -translate-y-1/2 text-gray-400;\r\n        }\r\n    }\r\n\r\n    &.has-error {\r\n        select {\r\n            @apply border-red-500 focus:border-red-600;\r\n        }\r\n\r\n        label {\r\n            @apply text-red-500 peer-focus:text-red-600;\r\n        }\r\n    }\r\n}\r\n\r\n.select-floating-wrapper .input-error-message {\r\n    @apply mt-1 text-xs text-red-500;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
